export default "dist/images/5aa87b7de67a77c914088783b055e1cf.png";